import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20Korean%20manhwa%20style%20background%20with%20soft%20flowing%20lines%20and%20warm%20coral%20orange%20gradient%20accents%2C%20minimal%20modern%20design%2C%20clean%20composition%2C%20subtle%20texture%2C%20dreamy%20atmosphere%2C%20digital%20art%2C%20smooth%20gradients%2C%20warm%20and%20inviting%20mood%2C%20no%20text%2C%20abstract%20geometric%20shapes%2C%20soft%20focus&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
        alt="韩漫画网背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <p className="text-primary-300 text-sm md:text-base font-medium mb-4 tracking-wider">
              高清免费韩国漫画大全
            </p>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight mb-4">
              最新热门漫画
              <br />
              <span className="font-heading italic text-primary-300">在线阅读</span>
            </h1>
            <p className="text-background-50/70 text-sm md:text-base max-w-md mx-auto lg:mx-0 mb-8 leading-relaxed">
              涵盖恋爱、奇幻、动作、悬疑等多种题材，画质清晰内容精彩，每日更新不断，满足每一位漫画爱好者的阅读需求。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="w-full sm:w-auto px-7 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors text-center cursor-pointer"
              >
                立即阅读
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-7 py-3 rounded-full border-2 border-background-50/30 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-background-50/10 transition-colors text-center cursor-pointer"
              >
                了解更多
              </Link>
            </div>

            <div className="flex items-center gap-6 mt-10 justify-center lg:justify-start">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-extrabold text-background-50">2,500+</p>
                <p className="text-xs text-background-50/60 mt-1">漫画作品</p>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-extrabold text-background-50">800万+</p>
                <p className="text-xs text-background-50/60 mt-1">活跃读者</p>
              </div>
              <div className="w-px h-8 bg-background-50/20"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-extrabold text-background-50">每日更新</p>
                <p className="text-xs text-background-50/60 mt-1">稳定连载</p>
              </div>
            </div>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="relative w-[260px] md:w-[320px] lg:w-[380px]">
              <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/30 transform rotate-1">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20featured%20cover%20art%2C%20beautiful%20fantasy%20romance%20scene%20with%20elegant%20couple%20under%20moonlight%2C%20coral%20pink%20and%20deep%20purple%20color%20palette%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20digital%20illustration%2C%20soft%20romantic%20lighting%2C%20stylish%20character%20design%2C%20magical%20sparkles&width=400&height=560&seq=hero-featured-comic&orientation=portrait"
                  alt="本周推荐漫画"
                  className="w-full aspect-[5/7] object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-4 py-2.5 shadow-lg">
                <p className="text-xs text-foreground-500">本周推荐</p>
                <p className="text-sm font-bold text-foreground-900">星光坠落时</p>
                <div className="flex items-center gap-1 mt-0.5">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-primary-500 text-xs"></i>
                  </div>
                  <span className="text-xs font-semibold text-primary-500">9.6</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}